import config from 'react-global-configuration';

export const APP_ENV = process.env.REACT_APP_ENV;
export const __DEBUG__ = APP_ENV !== 'production';
export const USE_SENTRY = APP_ENV !== 'development' && process.env.REACT_APP_SENTRY_ENABLED;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const DEFAULT_LANGUAGE = process.env.REACT_APP_DEFAULT_LANGUAGE || 'nl';
export const SITE_NAME = process.env.REACT_APP_SITE_NAME || 'onderdepannen';
export const APP_ROOT_ELEMENT_ID = 'root';

export const IS_SERVER = !(
  typeof window !== 'undefined'
  && window.document
  && window.document.createElement
);
export const IS_CLIENT = !IS_SERVER;

// let API_URL = process.env.REACT_APP_API_URL || "http://odp-2021.devinc.eu";
let API_URL = 'http://localhost:3000/api'; // <- For local proxy.

// If we provide the API URL in the DOM, use that instead.
if (IS_CLIENT && document.getElementById(APP_ROOT_ELEMENT_ID).dataset.apiUrl) {
  API_URL = document.getElementById(APP_ROOT_ELEMENT_ID).dataset.apiUrl;
}

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/src/src/styles/assets/_variables.scss'.
export const SCREEN_MOBILE = 0;
export const SCREEN_MEDIUM = 576;
export const SCREEN_TABLET = 768;
export const SCREEN_NORMAL = 992;
export const SCREEN_WIDE = 1240;
export const SCREEN_HUGE = 2000;

// Testimonial view.
export const TESTIMONIAL_VIEW_ID = 'testimonial';
export const TESTIMONIAL_VIEW_BLOCK_3 = 'block_3';

// Node types.
export const NODE_TYPE_MUNICIPALITY = 'municipality';
export const NODE_TYPE_FRONT_PAGE = 'front_page';
export const NODE_TYPE_LANDING_PAGE = 'landing_page';
export const NODE_TYPE_BASIC_PAGE = 'basic_page';
export const NODE_TYPE_ARTICLE = 'article';

// Use config to share static configuration between components and packages.
config.set({
  'SITE_NAME': SITE_NAME,
  'MULTILINGUAL': false,
  'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
  'API_URL': API_URL,
});

// Custom ODP constants.
export const NODE_TYPES_WITHOUT_PAGE = [
  'faq',
];

